const PbxxRecord = require('../../pbxx_record')

module.exports = class CampaignReportingStateLocations extends PbxxRecord {
  static get class_name() {
    return 'CampaignReportingStateLocations'
  }
}
